import React, { useEffect, useRef, useState } from "react";
import NavigationBar from "../../components/navbar";
import Footer from "../../components/footer";
import { useUI } from "../../contexts/UICtx";
import { motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthCtx";
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useOnClickOutside } from "../../hooks/useOnClickOutside";
import FooterNew from "../../sections/Footer";
import { CookiesDialog, CookiesPopups } from "../../sections/Dialog";
import { Link } from "react-router-dom";


const NavLogo = (props) => (
  <svg
    width={139}
    height={139}
    viewBox="0 0 139 139"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69 2C46.9086 2 29 20.5025 29 43.3265V95.6735C29 118.497 46.9086 137 69 137C90.1953 137 107.54 119.968 108.913 98.4286H61V90.1633H109V73.6327H61V65.3673H109V48.8367H61V40.5714H108.913C107.54 19.032 90.1953 2 69 2Z"
      fill={props.navigation_mode === null ? (props.scrolled ? "#10c96d" : "#ffffff") : props.navigation_mode === "normal" ? "#10c96d" : ""}
    />
  </svg>
);



const NavBar = ({ hasScolledUpdate }) => {

  const [scrollY, setScrollY] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrollingUp, setIsScrollingUp] = useState(true);

  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [mobileMenuAppear, setMobileMenuAppear] = useState(false);

  const heightRef = useRef(-100);

  const authCtx = useAuth();

  useEffect(() => {
    if(mobileMenuActive) {
      setTimeout(() => {
        setMobileMenuAppear(true)
      }, 100);
    }
    else
    {
      setTimeout(() => {
        setMobileMenuAppear(false)
      }, 100);
    }
  }, [mobileMenuActive]);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < 14) {
      setIsScrollingUp(true);
      hasScolledUpdate(currentScrollY)
      setScrollY(currentScrollY);
    }
    else if (currentScrollY < lastScrollY && currentScrollY > 70) {
      setIsScrollingUp(true);
    } else if (currentScrollY > lastScrollY || currentScrollY <= 70) {
      setIsScrollingUp(false);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {

    setScrollY(window.scrollY);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    if (authCtx.open_popups.show_cookies) {
      heightRef.current = -180;
    }
  }, [authCtx.open_popups]);

  return (
    <>
      <motion.header
        initial={{ y: 0 }}
        animate={{ y: isScrollingUp ? 0 : heightRef.current }}
        className={(authCtx.navigation_mode === null ? (scrollY > 0 ? "has-scrolled" : "") : authCtx.navigation_mode === "normal" ? "always-normal" : "")+(mobileMenuAppear ? " mb-menu-active" : "")}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        style={{
          position: 'fixed',
          top: 0,
          width: '100vw',
          zIndex: 1000
        }}
        role="navigation"
        ariaLabel="Main navigation"
      >
        <div className="inner">
          <ul>
            <li>
              <a href="/">
                <span>
                  <NavLogo navigation_mode={mobileMenuAppear ? "normal" : authCtx.navigation_mode} scrolled={scrollY > 0} width={30} />
                </span>
              </a>
            </li>
            <li>
              <a onClick={(e) => {
                e.preventDefault();
                authCtx.setGetQuote(true);
              }} className="text-button small-tx" href="#">GET QUOTE {'↗'}</a>
            </li>
          </ul>

          <ul>
            <li>
              <ul className={("navlinks")+(mobileMenuActive ? " active" : "")+(mobileMenuAppear ? " mb-menu" : "")}>
                <li>
                  <a href="/services">
                    {/* <span className="alert">FREE CONSULTATION</span> */}
                    <span>Services</span>
                  </a>
                </li>
                <li>
                  <a href="/hire_help">
                    <span>Hire help</span>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://blog.equibre.com">
                    <span>Blogs</span>
                  </a>
                </li>
                <li>
                  <a href="/career">
                    <span>Career</span>
                  </a>
                </li>
                {/* <li>
                  <span className="humb-shape">
                    <span className="menu-humb"></span>
                    <span className="menu-text">M</span>
                  </span>
                </li> */}
                {/* <li> */}
                {/* <a href="#" style={{marginLeft: 14}}> */}
                {/* <span>
                    <button className="get-quote-button">Get quote</button>
                  </span> */}
                {/* </a> */}
                {/* </li> */}
              </ul>
            </li>
            {/* <li> */}
              {/* <ul>
                <li>
                  <button className="get-quote-button">Get quote</button>
                </li>
              </ul> */}
            {/* </li> */}

            <li>
              <ul className="humb-menu">
                <li>
                  <span onClick={(e) => setMobileMenuActive(!mobileMenuActive)} className="humb-shape">
                    <span className="menu-line"></span>
                    <span className="menu-line"></span>
                    {/* <span className="menu-humb"></span> */}
                    {/* <span className="menu-text">M</span> */}
                  </span>
                </li>
              </ul>
            </li>


          </ul>
        </div>
        {authCtx.open_popups.show_cookies && <CookiesDialog />}
      </motion.header>
    </>
  );
}

const useFocusVisible = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Tab' || event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        document.body.classList.add('keyboard-focus');
        document.body.classList.remove('no-focus-outline');
      }
    };

    const handleMouseDown = () => {
      document.body.classList.remove('keyboard-focus');
      document.body.classList.add('no-focus-outline');
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);
};


export default function AppPage({ children }) {
  const authCtx = useAuth();

  useFocusVisible();

  return (
    <>
      <NavBar hasScolledUpdate={(s) => {
        authCtx.set_page_scroll(s);
      }} />
      {children}
      <CookiesPopups hasScrolled={authCtx.page_scroll} />
      <FooterNew />
    </>
  );
}
